module.exports = __webpack_public_path__ + "img/mo.b3745e0f.png";